import { useState } from 'react';

import { useAuthContext } from 'state/auth';

import { useAutoEnrollUserInLoyaltyMutation } from '../../generated/rbi-graphql';

type TEnrollmentState = null | 'enrolling' | 'enrolled';

export const useAutoEnrollUserInLoyalty = () => {
  const { isAuthenticated, user } = useAuthContext();

  const [enrollmentState, setEnrollmentState] = useState<TEnrollmentState>(null);

  const [createLoyaltyUser] = useAutoEnrollUserInLoyaltyMutation();

  const shouldAutoEnroll = isAuthenticated() && !user?.loyaltyId && enrollmentState === null;

  if (!shouldAutoEnroll) {
    return;
  }

  const tryToEnroll = async () => {
    setEnrollmentState('enrolling');
    const response = await createLoyaltyUser();

    if (response.data?.autoEnrollUserInLoyalty.loyaltyId) {
      setEnrollmentState('enrolled');
    }
  };

  tryToEnroll();
};
